import { ID_DOCUMENT_TYPE_NAME } from "@/types/document";
import type { DocumentSummary } from "@/types/document";
import type { Page } from "@/types/pagination";

import { getPatientDocuments } from "./document";

export const documentQueryKeys = {
  all: ["user", "patient", "documents"] as const,
  list: (patientId: string) => [...documentQueryKeys.all, patientId] as const,
  idList: (patientId: string) =>
    [...documentQueryKeys.list(patientId), "id"] as const,
};

export const documentQueryOptions = {
  list: (patientId: string) => ({
    queryKey: documentQueryKeys.list(patientId),
    queryFn: () => getPatientDocuments(patientId),
    select: (data: Page<DocumentSummary> | null) => data?.data ?? [],
  }),
  // Only the patient's identity documents (server-side filtered), used to pin
  // the most recent ID near the top of the chart.
  idDocuments: (patientId: string) => ({
    queryKey: documentQueryKeys.idList(patientId),
    queryFn: () =>
      getPatientDocuments(patientId, { docType: ID_DOCUMENT_TYPE_NAME }),
    select: (data: Page<DocumentSummary> | null) => data?.data ?? [],
  }),
};
